import { AppState } from 'mk2/reducers';

export const getForumSearchQuery = (state: AppState) => state.containers.forum.forumSearch.query;
